<template>
	<label class="nk-radio">
		<input type="radio" @change="valueChanged" @click="radioClicked" class="radio-input" :id="settings.id" :name="group" :value="settings.value" :disabled="disabled ? true : null" ref="input">
		<span :class="['radio-span', `color-${settings.color}`, settings.class, { 'disabled': disabled }]" :style="settings.style" :tabindex="tabindex">{{ settings.title }}</span>

	</label>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: {
			options: { type: Object },
			group: { type: String },
			modelValue: { type: [String, Boolean] },
			tabindex: { type: [Number, String] },
			disabled: { type: Boolean, default: false },
		},
		emits: ['update:modelValue', 'click'],
		data() {
			return {
				settings: {
					title: '',
					class: '',
					color: '',
					id: '',
					theme: '',
					value: '',
					style: '',
					isChecked: false,
				}
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.init()
		},
		watch: {
			modelValue: {
				handler(val) {
					this.init()
				}
			}
		},
		methods: {
			init() {
				if (this.modelValue === this.settings.value || this.settings.isChecked)
					this.$refs.input.checked = true
				else
					this.$refs.input.checked = false
			},
			radioClicked() {
				this.$emit('click', this.settings.value)
			},
			valueChanged() {
				this.$emit('update:modelValue', this.settings.value)
			}
		},
	}
</script>

<style scoped lang='less'></style>